import React, { useEffect, useMemo, useState } from 'react';
import './PlatformAdminPage.css';

const PIc = {
  grid: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <rect x="2.5" y="2.5" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="2.5" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
      <rect x="2.5" y="10" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="10" width="5.5" height="5.5" rx="1.3" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  build: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M3 15V7l6-4 6 4v8" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M7 15v-4h4v4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
  card: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <rect x="2.5" y="4" width="13" height="10" rx="1.6" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2.5 7.5h13" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  pulse: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M2 9h3l2-5 4 10 2-5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  flag: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M5 16V3M5 3h8l-1.6 2.6L13 8H5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 18 18" width="16" height="16" fill="none">
      <circle cx="8" cy="8" r="5" stroke="currentColor" strokeWidth="1.6" />
      <path d="M12 12l3.5 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  enter: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M9.5 2.5H4a1 1 0 00-1 1v9a1 1 0 001 1h5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 8h7M11.5 5.5L14 8l-2.5 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  up: (
    <svg viewBox="0 0 12 12" width="11" height="11" fill="none">
      <path d="M6 9.5V3M6 3L3 6M6 3l3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  down: (
    <svg viewBox="0 0 12 12" width="11" height="11" fill="none">
      <path d="M6 2.5V9M6 9L3 6M6 9l3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  dot: (
    <svg viewBox="0 0 8 8" width="8" height="8">
      <circle cx="4" cy="4" r="4" fill="currentColor" />
    </svg>
  ),
  queue: (
    <svg viewBox="0 0 18 18" width="17" height="17" fill="none">
      <path d="M6.5 5h8.5M6.5 9h8.5M6.5 13h8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="3" cy="5" r="1.3" fill="currentColor" />
      <circle cx="3" cy="9" r="1.3" fill="currentColor" />
      <circle cx="3" cy="13" r="1.3" fill="currentColor" />
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <rect x="2" y="3.5" width="12" height="9" rx="1.4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2.6 4.5L8 8.5l5.4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  clock: (
    <svg viewBox="0 0 16 16" width="13" height="13" fill="none">
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 5v3.2l2 1.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  close: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  ),
  warn: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M8 2L1.5 13.5h13L8 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 6.5v3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11.8" r="0.7" fill="currentColor" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none">
      <path d="M3 8.5l3.5 3.5L13 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  logo: (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none">
      <path d="M10 2.5l6.5 3.75v7.5L10 17.5l-6.5-3.75v-7.5L10 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10 7.5v5M7.5 9l5 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
};

const WORKSPACES = [
  { id: 'acme', name: 'Acme · Localization', slug: 'acme-localization', plan: 'Team', seats: 14, mrr: 1120, status: 'active', langs: 6, health: 98, last: '2 min ago', owner: 'Mira Kovač', created: 'Jan 2026' },
  { id: 'northwind', name: 'Northwind Global', slug: 'northwind', plan: 'Business', seats: 42, mrr: 4200, status: 'active', langs: 18, health: 99, last: '11 min ago', owner: 'Daniel Brecht', created: 'Nov 2025' },
  { id: 'lumen', name: 'Lumen Health', slug: 'lumen-health', plan: 'Business', seats: 31, mrr: 3100, status: 'active', langs: 12, health: 96, last: '1 h ago', owner: 'Priya Nair', created: 'Oct 2025' },
  { id: 'vela', name: 'Vela Commerce', slug: 'vela', plan: 'Team', seats: 9, mrr: 720, status: 'active', langs: 4, health: 97, last: '26 min ago', owner: 'Tom Achterberg', created: 'Feb 2026' },
  { id: 'kraft', name: 'Kraftwerk Studio', slug: 'kraftwerk', plan: 'Team', seats: 11, mrr: 880, status: 'past_due', langs: 5, health: 91, last: '3 h ago', owner: 'Lena Vogt', created: 'Dec 2025' },
  { id: 'pinecone', name: 'Pinecone Labs', slug: 'pinecone', plan: 'Trial', seats: 3, mrr: 0, status: 'trial', langs: 2, health: 94, last: 'yesterday', owner: 'Sam Reyes', created: 'May 2026' },
  { id: 'orbital', name: 'Orbital Docs', slug: 'orbital', plan: 'Enterprise', seats: 120, mrr: 9800, status: 'active', langs: 24, health: 99, last: 'just now', owner: 'Yara Haddad', created: 'Aug 2025' },
  { id: 'fjord', name: 'Fjord Media', slug: 'fjord', plan: 'Trial', seats: 2, mrr: 0, status: 'trial', langs: 3, health: 88, last: '4 d ago', owner: 'Ola Nilsen', created: 'May 2026' },
  { id: 'bloom', name: 'Bloom & Co', slug: 'bloom', plan: 'Team', seats: 7, mrr: 560, status: 'canceled', langs: 3, health: 0, last: '12 d ago', owner: 'Inès Faure', created: 'Sep 2025' },
];

const PLAN_TONE = { Trial: 'trial', Team: 'team', Business: 'biz', Enterprise: 'ent' };
const STATUS_TONE = { active: 'ok', trial: 'info', past_due: 'warn', canceled: 'muted' };
const STATUS_LABEL = { active: 'Active', trial: 'Trial', past_due: 'Past due', canceled: 'Canceled' };

const SERVICES = [
  { name: 'API', status: 'ok', note: 'p95 142 ms' },
  { name: 'Web app', status: 'ok', note: 'operational' },
  { name: 'AI drafting (Rush AI)', status: 'ok', note: 'queue 1.2 s' },
  { name: 'Translation memory', status: 'degraded', note: 'elevated latency' },
  { name: 'Integrations sync', status: 'ok', note: 'operational' },
  { name: 'Billing (Stripe)', status: 'ok', note: 'operational' },
];

const SIGNUPS = [4, 6, 5, 8, 7, 9, 11, 10, 13, 12, 15, 14];
const MRR_TREND = [18.4, 19.1, 19.8, 20.6, 21.2, 22.0, 22.8, 23.4, 24.1, 24.9, 25.6, 26.3];

const EVENTS = [
  { t: 'Pinecone Labs', s: 'started a Trial', time: '1 h ago', tone: 'info' },
  { t: 'Orbital Docs', s: 'upgraded Business → Enterprise', time: '5 h ago', tone: 'ok' },
  { t: 'Kraftwerk Studio', s: 'payment failed — past due', time: '8 h ago', tone: 'warn' },
  { t: 'Fjord Media', s: 'started a Trial', time: 'yesterday', tone: 'info' },
  { t: 'Bloom & Co', s: 'canceled Team plan', time: '2 d ago', tone: 'muted' },
];

const WAITLIST = [
  { id: 'w1', name: 'Hannah Osei', email: 'hannah@meridian.io', company: 'Meridian Health', seats: 30, interest: 'Patient-facing docs', source: 'Outbound', joined: 'May 28', wait: 3, status: 'waiting' },
  { id: 'w2', name: 'Diego Marin', email: 'diego@flux-commerce.com', company: 'Flux Commerce', seats: 12, interest: 'Storefront strings', source: 'Product Hunt', joined: 'May 27', wait: 4, status: 'waiting' },
  { id: 'w3', name: 'Aiko Tanaka', email: 'aiko@nori.design', company: 'Nori Design Co', seats: 6, interest: 'Marketing site', source: 'Referral', joined: 'May 26', wait: 5, status: 'waiting' },
  { id: 'w4', name: 'Marcus Bell', email: 'm.bell@arcadia.dev', company: 'Arcadia', seats: 45, interest: 'Product UI + docs', source: 'Conference', joined: 'May 24', wait: 7, status: 'invited' },
  { id: 'w5', name: 'Sofia Romano', email: 'sofia@belcanto.it', company: 'Belcanto Media', seats: 9, interest: 'Editorial content', source: 'Website', joined: 'May 23', wait: 8, status: 'waiting' },
  { id: 'w6', name: 'Theo Lindqvist', email: 'theo@saga-labs.se', company: 'Saga Labs', seats: 18, interest: 'Mobile app strings', source: 'Referral', joined: 'May 21', wait: 10, status: 'invited' },
  { id: 'w7', name: 'Priya Raman', email: 'priya@taraa.in', company: 'Taraa', seats: 4, interest: 'Help center', source: 'Product Hunt', joined: 'May 19', wait: 12, status: 'activated' },
  { id: 'w8', name: 'Lucas Mendoza', email: 'lucas@cordillera.cl', company: 'Cordillera', seats: 22, interest: 'E-commerce + email', source: 'Outbound', joined: 'May 16', wait: 15, status: 'waiting' },
  { id: 'w9', name: 'Emma Voss', email: 'emma@kelp.studio', company: 'Kelp Studio', seats: 7, interest: 'Brand microcopy', source: 'Website', joined: 'May 14', wait: 17, status: 'activated' },
  { id: 'w10', name: 'Noah Adeyemi', email: 'noah@lagos-fintech.com', company: 'Lagos Fintech', seats: 28, interest: 'App + compliance', source: 'Conference', joined: 'May 11', wait: 20, status: 'invited' },
  { id: 'w11', name: 'Clara Bauer', email: 'clara@hof-and-co.de', company: 'Hof & Co', seats: 5, interest: 'Catalog', source: 'Referral', joined: 'May 8', wait: 23, status: 'declined' },
  { id: 'w12', name: 'Yusuf Karim', email: 'yusuf@minareh.ae', company: 'Minareh', seats: 14, interest: 'Web + knowledge base', source: 'Outbound', joined: 'May 5', wait: 26, status: 'activated' },
];

const WL_STATUS_LABEL = { waiting: 'Waiting', invited: 'Invited', activated: 'Activated', declined: 'Declined' };
const WL_JOINS = [9, 12, 11, 15, 14, 18, 17, 22, 21, 26, 28, 33];
const WL_SOURCES = [
  ['Product Hunt', 412, 's0'],
  ['Referral', 328, 's1'],
  ['Outbound', 274, 's2'],
  ['Website', 196, 's3'],
  ['Conference', 74, 's4'],
];

const avatarBg = (id) => {
  const palette = ['var(--pa-av-0)', 'var(--pa-av-1)', 'var(--pa-av-2)', 'var(--pa-av-3)', 'var(--pa-av-4)'];
  return palette[id.length % palette.length];
};

const Spark = ({ data, color, w = 150, h = 40, fill = true }) => {
  const pad = 3;
  const max = Math.max(...data);
  const min = Math.min(...data);
  const r = max - min || 1;
  const step = (w - pad * 2) / (data.length - 1);
  const pts = data.map((v, i) => [pad + i * step, h - pad - ((v - min) / r) * (h - pad * 2)]);
  const d = pts.map((p, i) => (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ');
  return (
    <svg className="pa-spark" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" fill="none">
      {fill && (
        <path
          d={`${d} L ${pts[pts.length - 1][0]} ${h} L ${pts[0][0]} ${h} Z`}
          fill={color}
          opacity="0.13"
        />
      )}
      <path d={d} stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const Stat = ({ label, value, delta, arrow, tone, spark, color }) => (
  <div className="pa-stat">
    <div className="pa-stat-l">{label}</div>
    <div className="pa-stat-v">{value}</div>
    <div className="pa-stat-row">
      {delta && (
        <span className={`pa-delta ${tone || ''}`}>
          {arrow === 'down' ? PIc.down : PIc.up}
          {delta}
        </span>
      )}
      {spark && <Spark data={spark} color={color} w={108} h={28} />}
    </div>
  </div>
);

const Overview = ({ onGo }) => (
  <div className="pa-view">
    <div className="pa-grid-4">
      <Stat label="MRR" value="$26.3k" delta="+3.2%" arrow="up" tone="ok" spark={MRR_TREND} color="var(--pa-accent)" />
      <Stat label="Active workspaces" value="142" delta="+6" arrow="up" tone="ok" spark={SIGNUPS} color="#2da06a" />
      <Stat label="Paid seats" value="2,418" delta="+74" arrow="up" tone="ok" />
      <Stat label="Trials in flight" value="23" delta="9 converting" arrow="up" tone="info" />
    </div>

    <div className="pa-row-2">
      <div className="pa-card">
        <div className="pa-card-h">
          <h3>Recent activity</h3>
          <button type="button" className="pa-link" onClick={() => onGo('workspaces')}>
            All workspaces {PIc.enter}
          </button>
        </div>
        <div className="pa-events">
          {EVENTS.map((e, i) => (
            <div className="pa-event" key={i}>
              <span className={`pa-ev-dot ${e.tone}`}>{PIc.dot}</span>
              <div className="pa-ev-b">
                <b>{e.t}</b> {e.s}
              </div>
              <span className="pa-ev-t">{e.time}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="pa-card">
        <div className="pa-card-h">
          <h3>System status</h3>
          <span className="pa-status-pill ok">{PIc.check} Operational</span>
        </div>
        <div className="pa-services">
          {SERVICES.map((s) => (
            <div className="pa-service" key={s.name}>
              <span className={`pa-svc-dot ${s.status}`}></span>
              <span className="pa-svc-n">{s.name}</span>
              <span className="pa-svc-note">{s.note}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const WorkspaceDir = ({ onImpersonate }) => {
  const [q, setQ] = useState('');
  const [plan, setPlan] = useState('All');
  const plans = ['All', 'Trial', 'Team', 'Business', 'Enterprise'];
  const rows = WORKSPACES.filter(
    (w) =>
      (plan === 'All' || w.plan === plan) &&
      (!q ||
        w.name.toLowerCase().includes(q.toLowerCase()) ||
        w.slug.includes(q.toLowerCase()) ||
        w.owner.toLowerCase().includes(q.toLowerCase()))
  );
  return (
    <div className="pa-view">
      <div className="pa-toolbar">
        <div className="pa-search">
          {PIc.search}
          <input
            placeholder="Search workspaces, slugs, owners…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="pa-seg">
          {plans.map((p) => (
            <button key={p} type="button" className={plan === p ? 'on' : ''} onClick={() => setPlan(p)}>
              {p}
            </button>
          ))}
        </div>
        <div className="grow"></div>
        <span className="pa-count">
          {rows.length} of {WORKSPACES.length}
        </span>
      </div>

      <div className="pa-card pa-tablewrap">
        <table className="pa-table">
          <thead>
            <tr>
              <th>Workspace</th>
              <th>Plan</th>
              <th className="num">Seats</th>
              <th className="num">MRR</th>
              <th>Status</th>
              <th>Last active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((w) => (
              <tr key={w.id}>
                <td>
                  <div className="pa-ws">
                    <span className="pa-ws-av" style={{ background: avatarBg(w.id) }}>
                      {w.name[0]}
                    </span>
                    <div className="pa-ws-b">
                      <b>{w.name}</b>
                      <span>
                        rush.studio/{w.slug} · {w.owner}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <span className={`pa-plan ${PLAN_TONE[w.plan]}`}>{w.plan}</span>
                </td>
                <td className="num">{w.seats}</td>
                <td className="num">{w.mrr ? '$' + w.mrr.toLocaleString() : '—'}</td>
                <td>
                  <span className={`pa-st ${STATUS_TONE[w.status]}`}>{STATUS_LABEL[w.status]}</span>
                </td>
                <td className="muted">{w.last}</td>
                <td className="right">
                  <button
                    type="button"
                    className="pa-imp-btn"
                    onClick={() => onImpersonate(w)}
                    disabled={w.status === 'canceled'}
                    title={w.status === 'canceled' ? 'Workspace canceled' : 'Open this workspace as its admin'}
                  >
                    {PIc.enter}
                    <span>Impersonate</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const Billing = () => {
  const byPlan = [
    ['Enterprise', 9800, 'ent'],
    ['Business', 7300, 'biz'],
    ['Team', 3960, 'team'],
    ['Trial', 0, 'trial'],
  ];
  const total = byPlan.reduce((a, p) => a + p[1], 0);
  return (
    <div className="pa-view">
      <div className="pa-grid-4">
        <Stat label="MRR" value="$26.3k" delta="+3.2%" arrow="up" tone="ok" />
        <Stat label="ARR (run-rate)" value="$315k" delta="+12%" arrow="up" tone="ok" />
        <Stat label="Net revenue retention" value="114%" delta="+2 pts" arrow="up" tone="ok" />
        <Stat label="Failed payments" value="1" delta="Kraftwerk" arrow="down" tone="warn" />
      </div>
      <div className="pa-row-2">
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>MRR by plan</h3>
          </div>
          <div className="pa-bars">
            {byPlan.map(([name, v, tone]) => (
              <div className="pa-bar-row" key={name}>
                <span className="pa-bar-l">{name}</span>
                <span className="pa-bar-track">
                  <span
                    className={`pa-bar ${tone}`}
                    style={{ width: (total ? (v / total) * 100 : 0) + '%' }}
                  ></span>
                </span>
                <span className="pa-bar-v">{v ? '$' + v.toLocaleString() : '—'}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>Recent invoices</h3>
          </div>
          <div className="pa-events">
            {[
              ['Orbital Docs', '$9,800', 'Paid', 'ok'],
              ['Northwind Global', '$4,200', 'Paid', 'ok'],
              ['Lumen Health', '$3,100', 'Paid', 'ok'],
              ['Kraftwerk Studio', '$880', 'Failed', 'warn'],
            ].map(([n, a, s, tone], i) => (
              <div className="pa-event" key={i}>
                <span className={`pa-ev-dot ${tone}`}>{PIc.dot}</span>
                <div className="pa-ev-b">
                  <b>{n}</b> · {a}
                </div>
                <span className={`pa-inv ${tone}`}>{s}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const WaitingList = () => {
  const [rows, setRows] = useState(WAITLIST);
  const [q, setQ] = useState('');
  const [seg, setSeg] = useState('All');
  const segs = ['All', 'Waiting', 'Invited', 'Activated', 'Declined'];

  const invite = (id) =>
    setRows((rs) => rs.map((r) => (r.id === id ? { ...r, status: 'invited' } : r)));
  const inviteNext = () =>
    setRows((rs) => {
      let n = 10;
      return rs.map((r) => (r.status === 'waiting' && n-- > 0 ? { ...r, status: 'invited' } : r));
    });

  const waitingCount = rows.filter((r) => r.status === 'waiting').length;
  const counts = {
    All: rows.length,
    Waiting: waitingCount,
    Invited: rows.filter((r) => r.status === 'invited').length,
    Activated: rows.filter((r) => r.status === 'activated').length,
    Declined: rows.filter((r) => r.status === 'declined').length,
  };
  const view = rows.filter(
    (r) =>
      (seg === 'All' || WL_STATUS_LABEL[r.status] === seg) &&
      (!q ||
        r.name.toLowerCase().includes(q.toLowerCase()) ||
        r.company.toLowerCase().includes(q.toLowerCase()) ||
        r.email.toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <div className="pa-view">
      <div className="pa-grid-4">
        <Stat label="On the waitlist" value="1,284" delta="+33 this week" arrow="up" tone="info" spark={WL_JOINS} color="var(--pa-accent)" />
        <Stat label="Invited (7 days)" value="86" delta="+18%" arrow="up" tone="ok" />
        <Stat label="Activation rate" value="62%" delta="+4 pts" arrow="up" tone="ok" />
        <Stat label="Median wait" value="9 d" delta="−2 d" arrow="down" tone="ok" />
      </div>

      <div className="pa-row-2">
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>Requests over time</h3>
            <span className="pa-muted-note">Last 12 weeks</span>
          </div>
          <div className="pa-wl-trend">
            <Spark data={WL_JOINS} color="var(--pa-accent)" w={420} h={104} />
            <div className="pa-wl-trend-foot">
              <span>
                <b>33</b> joined this week
              </span>
              <span className="pa-delta ok">{PIc.up}+57% vs. 6 wks ago</span>
            </div>
          </div>
        </div>
        <div className="pa-card">
          <div className="pa-card-h">
            <h3>Top sources</h3>
            <span className="pa-muted-note">All-time signups</span>
          </div>
          <div className="pa-bars">
            {WL_SOURCES.map(([name, v, tone]) => {
              const max = Math.max(...WL_SOURCES.map((s) => s[1]));
              return (
                <div className="pa-bar-row" key={name}>
                  <span className="pa-bar-l">{name}</span>
                  <span className="pa-bar-track">
                    <span className={`pa-bar ${tone}`} style={{ width: (v / max) * 100 + '%' }}></span>
                  </span>
                  <span className="pa-bar-v">{v.toLocaleString()}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="pa-toolbar">
        <div className="pa-search">
          {PIc.search}
          <input
            placeholder="Search people, companies, emails…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="pa-seg">
          {segs.map((s) => (
            <button key={s} type="button" className={seg === s ? 'on' : ''} onClick={() => setSeg(s)}>
              {s} <span className="pa-seg-c">{counts[s]}</span>
            </button>
          ))}
        </div>
        <div className="grow"></div>
        <button type="button" className="pa-btn primary" onClick={inviteNext} disabled={!waitingCount}>
          {PIc.mail} Invite next {Math.min(10, waitingCount) || ''}
        </button>
      </div>

      <div className="pa-card pa-tablewrap">
        <table className="pa-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Person</th>
              <th>Interested in</th>
              <th className="num">Seats</th>
              <th>Source</th>
              <th>Joined</th>
              <th className="num">Wait</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {view.map((r) => (
              <tr key={r.id}>
                <td className="pa-pos">{rows.indexOf(r) + 1}</td>
                <td>
                  <div className="pa-ws">
                    <span className="pa-ws-av" style={{ background: avatarBg(r.id) }}>
                      {r.name[0]}
                    </span>
                    <div className="pa-ws-b">
                      <b>{r.name}</b>
                      <span>
                        {r.email} · {r.company}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="muted">{r.interest}</td>
                <td className="num">{r.seats}</td>
                <td>
                  <span className="pa-src">{r.source}</span>
                </td>
                <td className="muted">{r.joined}</td>
                <td className="num">
                  <span className="pa-wait">
                    {PIc.clock}
                    {r.wait}d
                  </span>
                </td>
                <td>
                  <span className={`pa-wl-st ${r.status}`}>{WL_STATUS_LABEL[r.status]}</span>
                </td>
                <td className="right">
                  {r.status === 'waiting' ? (
                    <button type="button" className="pa-invite" onClick={() => invite(r.id)}>
                      {PIc.mail}
                      <span>Invite</span>
                    </button>
                  ) : (
                    <span className="pa-invited-tag">
                      {r.status === 'activated'
                        ? PIc.check
                        : r.status === 'invited'
                        ? PIc.mail
                        : PIc.close}{' '}
                      {r.status === 'invited' ? 'Sent' : WL_STATUS_LABEL[r.status]}
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const SystemView = () => (
  <div className="pa-view">
    <div className="pa-card">
      <div className="pa-card-h">
        <h3>Services</h3>
        <span className="pa-status-pill ok">{PIc.check} All systems operational</span>
      </div>
      <div className="pa-services lg">
        {SERVICES.map((s) => (
          <div className="pa-service" key={s.name}>
            <span className={`pa-svc-dot ${s.status}`}></span>
            <span className="pa-svc-n">{s.name}</span>
            <span className="pa-svc-note">{s.note}</span>
            <span className={`pa-svc-tag ${s.status}`}>
              {s.status === 'ok' ? 'Operational' : 'Degraded'}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const FlagsView = () => {
  const [flags, setFlags] = useState({
    'adaptive-ai-v3': true,
    'in-context-preview': true,
    'automations-builder': true,
    'brand-voice-studio': true,
    'byo-mt-engine': false,
    'sso-scim': true,
    'usage-billing': false,
  });
  const meta = {
    'adaptive-ai-v3': 'Adaptive Rush AI drafting engine',
    'in-context-preview': 'Live overflow preview',
    'automations-builder': 'Continuous-localization rules',
    'brand-voice-studio': 'Per-language voice profiles',
    'byo-mt-engine': 'Bring-your-own MT (beta)',
    'sso-scim': 'SAML SSO + SCIM provisioning',
    'usage-billing': 'Usage-based billing (internal)',
  };
  return (
    <div className="pa-view">
      <div className="pa-card">
        <div className="pa-card-h">
          <h3>Feature flags</h3>
          <span className="pa-muted-note">Applies to all workspaces unless overridden</span>
        </div>
        <div className="pa-flags">
          {Object.keys(flags).map((k) => (
            <div className="pa-flag" key={k}>
              <div className="pa-flag-b">
                <code>{k}</code>
                <span>{meta[k]}</span>
              </div>
              <button
                type="button"
                className={`pa-switch ${flags[k] ? 'on' : ''}`}
                role="switch"
                aria-checked={flags[k]}
                onClick={() => setFlags((f) => ({ ...f, [k]: !f[k] }))}
              >
                <span></span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const NAV = [
  ['overview', 'Overview', PIc.grid],
  ['workspaces', 'Workspaces', PIc.build],
  ['waitlist', 'Waiting list', PIc.queue],
  ['billing', 'Billing & revenue', PIc.card],
  ['system', 'System status', PIc.pulse],
  ['flags', 'Feature flags', PIc.flag],
];

const TITLE_OF = {
  overview: 'Overview',
  workspaces: 'Workspaces',
  waitlist: 'Waiting list',
  billing: 'Billing & revenue',
  system: 'System status',
  flags: 'Feature flags',
};

const PlatformAdminPage = () => {
  const [view, setView] = useState('overview');
  const [imp, setImp] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const prev = document.body.style.background;
    document.body.style.background = '#fbfaf7';
    return () => {
      document.body.style.background = prev;
    };
  }, []);

  const body = useMemo(() => {
    switch (view) {
      case 'overview':
        return <Overview onGo={setView} />;
      case 'workspaces':
        return <WorkspaceDir onImpersonate={setImp} />;
      case 'waitlist':
        return <WaitingList />;
      case 'billing':
        return <Billing />;
      case 'system':
        return <SystemView />;
      case 'flags':
        return <FlagsView />;
      default:
        return null;
    }
  }, [view]);

  return (
    <div className="pa-app">
      <aside className="pa-rail">
        <div className="pa-brand">
          <span className="pa-brand-mark">{PIc.logo}</span>
          <div className="pa-brand-t">
            <b>Rush Studio</b>
            <span>Platform console</span>
          </div>
        </div>
        <div className="pa-staff-badge">{PIc.warn} Staff · internal</div>
        <nav className="pa-nav">
          {NAV.map(([id, label, ic]) => (
            <button
              type="button"
              key={id}
              className={`pa-nav-i ${view === id ? 'on' : ''}`}
              onClick={() => setView(id)}
            >
              <span className="ic">{ic}</span>
              {label}
            </button>
          ))}
        </nav>
        <div className="pa-rail-foot">
          <div className="pa-env">
            <span className="dot"></span>Production
          </div>
          <div className="pa-op">
            <span className="pa-op-av">OP</span>
            <div className="pa-op-b">
              <b>You</b>
              <span>Platform operator</span>
            </div>
          </div>
        </div>
      </aside>

      <div className="pa-main">
        {active && (
          <div className="pa-imp-banner">
            {PIc.warn}
            <span>
              You are impersonating <b>{active.name}</b> — actions are logged to the audit trail.
            </span>
            <div className="grow"></div>
            <a className="pa-imp-open" href="#/dashboard">
              Open workspace {PIc.enter}
            </a>
            <button type="button" className="pa-imp-exit" onClick={() => setActive(null)}>
              {PIc.close} Exit
            </button>
          </div>
        )}
        <header className="pa-head">
          <div>
            <div className="pa-crumb">
              Platform <span>/</span> {TITLE_OF[view]}
            </div>
            <h1>{TITLE_OF[view]}</h1>
          </div>
          <div className="pa-head-r">
            <span className="pa-region">All regions · USD</span>
          </div>
        </header>

        <div className="pa-body">{body}</div>
      </div>

      {imp && (
        <div
          className="pa-modal-wrap"
          onMouseDown={(e) => {
            if (e.target.classList.contains('pa-modal-wrap')) setImp(null);
          }}
        >
          <div className="pa-modal">
            <div className="pa-modal-ic">{PIc.enter}</div>
            <h2>Impersonate {imp.name}?</h2>
            <p>
              You'll enter <b>{imp.name}</b>'s workspace as an administrator to troubleshoot. This is
              recorded in the audit log and the workspace owner is notified. Use read-only care with
              customer data.
            </p>
            <div className="pa-modal-meta">
              <div>
                <span>Owner</span>
                <b>{imp.owner}</b>
              </div>
              <div>
                <span>Plan</span>
                <b>{imp.plan}</b>
              </div>
              <div>
                <span>Seats</span>
                <b>{imp.seats}</b>
              </div>
              <div>
                <span>Workspace</span>
                <b>rush.studio/{imp.slug}</b>
              </div>
            </div>
            <div className="pa-modal-actions">
              <button type="button" className="pa-btn" onClick={() => setImp(null)}>
                Cancel
              </button>
              <button
                type="button"
                className="pa-btn primary"
                onClick={() => {
                  setActive(imp);
                  setImp(null);
                }}
              >
                {PIc.enter} Start session
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlatformAdminPage;
